module.exports = __webpack_public_path__ + "static/wp-pazarlama-79667921042b13dcd3c695415a004090.webp";